import { isFaceState, type FaceState, type LevelId, type LevelNumber } from '@/state/types';

/**
 * Parse a `?level=` value. Accepts `L12`, `FALSE_ENDING`, `ENDGAME`.
 * Returns null on anything unrecognised so callers can ignore it silently.
 */
export function parseLevelParam(raw: string | null): LevelId | null {
  if (raw == null) return null;
  const v = raw.trim().toUpperCase();
  if (v === 'FALSE_ENDING') return { kind: 'FALSE_ENDING' };
  if (v === 'ENDGAME') return { kind: 'ENDGAME' };
  const match = /^L(\d{1,3})$/.exec(v);
  if (!match) return null;
  const nStr = match[1];
  if (nStr === undefined) return null;
  const n = Number.parseInt(nStr, 10);
  // Accept 0–MAX_LEVEL_NUMBER for canonical play, plus staging slots up to 40.
  if (!Number.isInteger(n) || n < 0 || n > 40) return null;
  return { kind: 'LEVEL', n: n as LevelNumber };
}

export function parseFaceParam(raw: string | null): FaceState | null {
  if (raw == null) return null;
  const v = raw.trim().toUpperCase();
  return isFaceState(v) ? v : null;
}

export function isDevPanelEnabled(search: string): boolean {
  if (import.meta.env.PROD) return false;
  return new URLSearchParams(search).has('dev');
}
